// SDK Modes
export var LOCALHOST_MODE = 'localhost';
export var STANDALONE_MODE = 'standalone';
export var PRODUCER_MODE = 'producer';
export var CONSUMER_MODE = 'consumer'; // Storage types

export var STORAGE_MEMORY = 'MEMORY';
export var STORAGE_REDIS = 'REDIS';
export var STORAGE_LOCALSTORAGE = 'LOCALSTORAGE'; // Special treatments

export var CONTROL = 'control';
export var CONTROL_WITH_CONFIG = {
  treatment: CONTROL,
  config: null
}; // Constants for unknown and not-applicable values

export var UNKNOWN = 'unknown';
export var NA = 'NA';


// WEBPACK FOOTER //
// /root/urbanmassage/node_modules/@splitsoftware/splitio/es/utils/constants/index.js